<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Manual
      <i class="fa fa-fw fa-question-circle" v-tooltip data-placement="right" title="Apply supplier product payload manually"></i>
    </div>
    <div class="panel-body">
      <div class="form-inline form-inline--better-spaced form-inline--compact-- form-inline--one-liner--">
        <div class="form-group">
          <label>Supplier</label>
          <select class="form-control" v-model="supplierId" :disabled="loading">
            <option :value="null">Sellect Supplier</option>
            <option v-for="(opt, key) in supplierOptions" :key="key" :value="opt.value" v-html="opt.label"></option>
          </select>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="applyPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-check"></i> Apply</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="clearForm" :disabled="(!formIsOk || loading) && !payload"><i class="fa fa-fw fa-times"></i> Clear</button>
        </div>
      </div>
      <div class="form-group">
        <label>Supplier Product Payload</label>
        <textarea class="form-control" v-model="payload" :disabled="loading"></textarea>
      </div>
    </div><!-- .panel-body -->
  </div><!-- .panel -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ApiResponseMixin from '@/plugin/mixin/api-response'
import Tooltip from '@/plugin/directive/tooltip'

export default {
  name: 'sync-by-manual-form-component',
  data() {
    return {
      supplierId: null,
      payload: null
    }
  },
  computed: {
    ...mapState('dropship/seller/syncProduct', {
      supplierOptions: 'supplierOptions'
    }),
    ...mapGetters('dropship/seller/syncProduct', {
      isRequestingServer: 'isRequestingServer'
    }),
    formIsOk() {
      return this.supplierId && this.payload
    },
    loading() {
      return this.isRequestingServer
    }
  },
  methods: {
    async applyPayload() {
      try {
        const response = await this.$store.dispatch(
          'dropship/seller/syncProduct/applyPayloadManually',
          {supplierId: this.supplierId, payload: this.payload}
        )
        if (response) {
          this.$alertify.success('Payload applied')
        } else {
          this.$alertify.error('Payload NOT applied')
        }
      } catch (reason) {
        if (this.isResponseError(reason)) {
          this.raiseErrorMessage(reason)
        } else {
          this.$alertify.error('An error was raised while requesting to apply payload.  Message: ' + reason)
        }
      }
    },
    clearForm() {
      this.supplierId = null
      this.payload = null
      this.$store.dispatch('dropship/seller/syncProduct/clearPayloadByProduct')
    }
  },
  directives: {
    tooltip: Tooltip
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
